// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginForm_formContainer__KT-D6","loginControl":"LoginForm_loginControl__Ej+SF","resend":"LoginForm_resend__ZA4fC","resendCount":"LoginForm_resendCount__z4eIy"};